import React from 'react'
import { Modal } from 'antd'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import { t } from '../config/i18n'
import { InputSearchBusiness } from '../components/shared/ui/InputSearchBusiness'
import { IBusinessSearchItem } from '../services/BusinessService'
import { SelectTaxonomy } from '../components/shared/ui/SelectTaxonomy'
import { ITaxonomyTreeItemSimple } from '../services/TaxonomyService'
import { TResource } from '../models/Resource'
import { SelectResource } from '../components/shared/ui/SelectResource'

interface IModalConfirm {
  title?: string
  closable?: boolean
  message?: string
  okText?: string
  cancelText?: string
  onOk: () => void
  onCancel?: () => void
}
export function modalConfirm(props: IModalConfirm) {
  Modal.confirm({
    title: props.title ?? 'Подтверждение',
    icon: <ExclamationCircleOutlined />,
    closable: props.closable ?? true,
    content: props.message ?? 'Вы уверены?',
    okText: props.okText ?? 'OK',
    cancelText: props.cancelText ?? t.common.cancel,
    onCancel: props.onCancel,
    onOk: props.onOk,
  })
}

export function modalSelectBusiness(): Promise<IBusinessSearchItem> {
  return new Promise<IBusinessSearchItem>((resolve, reject) => {
    const handleSelect = (item: IBusinessSearchItem) => {
      destroy()
      resolve(item)
    }
    const { destroy } = Modal.confirm({
      maskClosable: true,
      title: t.catalog.selectBusiness,
      icon: null,
      cancelText: t.common.cancel,
      okButtonProps: { style: { display: 'none'} },
      onCancel: () => reject(),
      content: (
        <InputSearchBusiness onSelect={handleSelect} />
      )
    })
  })
}

export function modalSelectTaxonomy(businessId: string): Promise<ITaxonomyTreeItemSimple> {
  return new Promise<ITaxonomyTreeItemSimple>((resolve, reject) => {
    const handleSelect = (businessId: string, item: ITaxonomyTreeItemSimple) => {
      destroy()
      resolve(item)
    }
    const { destroy } = Modal.confirm({
      maskClosable: true,
      title: t.catalog.selectTaxonomy,
      icon: null,
      cancelText: t.common.cancel,
      okButtonProps: { style: { display: 'none'} },
      onCancel: () => reject(),
      content: (
        <SelectTaxonomy
          businessId={businessId}
          onSelect={handleSelect}
        />
      )
    })
  })
}

export function modalSelectResource(businessId: string): Promise<TResource> {
  return new Promise<TResource>((resolve, reject) => {
    const handleSelect = (businessId: string, item: TResource) => {
      destroy()
      resolve(item)
    }
    const { destroy } = Modal.confirm({
      maskClosable: true,
      title: t.catalog.selectResource,
      icon: null,
      cancelText: t.common.cancel,
      okButtonProps: { style: { display: 'none'} },
      onCancel: () => reject(),
      content: (
        <SelectResource
          businessId={businessId}
          onSelect={handleSelect}
        />
      )
    })
  })
}
